import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'filterCollab',
})

export class Filter2Pipe implements PipeTransform {

  transform(data: any, term: any): any {

    //check if search term is undefined
    if (term === undefined) return data;
    //return updates data array
    return data?.filter(function (agent) {
      const matricule = agent?.matricule?.toLocaleLowerCase();
      const nom = agent?.nom?.toLocaleLowerCase();
      const prenoms = agent?.prenoms?.toLocaleLowerCase();
      const sexe = agent?.sexe ? agent?.sexe?.toLocaleLowerCase() : '';
      const statut = agent?.statut ? agent?.statut?.toLocaleLowerCase() : '';
      const categorie = agent?.categorie ? agent?.categorie?.toLocaleLowerCase() : '';
      const structure = agent?.structure?.code ? agent?.structure?.code.toLocaleLowerCase() : '';
      // const structure = agent?.structure ? agent?.structure?.toLocaleLowerCase() : '';
      const direction = agent?.direction ? agent?.direction?.toLocaleLowerCase() : '';
      // const n_plus_1 = agent?.n_plus_1 ? agent?.n_plus_1.toLocaleLowerCase() : '';
      // const n_plus_2 = agent?.n_plus_2 ? agent?.n_plus_2.toLocaleLowerCase() : '';
      // const respo_struct = agent?.respo_struct ? agent?.respo_struct.toLocaleLowerCase() : '';
      let searchValue = term.toLocaleLowerCase();
      return (
        matricule.includes(searchValue) ||
        nom.includes(searchValue) ||
        prenoms.includes(searchValue) ||
        statut.includes(searchValue) ||
        categorie.includes(searchValue) ||
        structure.includes(searchValue) ||
        direction.includes(searchValue) ||
        // n_plus_1.includes(searchValue) ||
        // n_plus_2.includes(searchValue) ||
        // respo_struct.includes(searchValue) ||
        sexe.includes(searchValue)
      )
    })
  }
}